import { Collection }        from '@mathquis/modelx';
import { observer }          from 'mobx-react';
import React                 from 'react';
import { ApiCollection }     from 'collections/ApiCollection';
import type { StandistRole } from 'constants/StandistRoleReference';
import UserStandRoleModel    from 'models/UserStandRoleModel';
import UserModel             from 'models/UserModel';

const Standists = observer(({
  handleOnClick,
  standistCollection,
  standistRole,
  userStandRoleCollection,
}: {
    handleOnClick: (user: UserModel) => void;
    standistCollection: Collection<UserModel>;
    standistRole: StandistRole;
    userStandRoleCollection: ApiCollection<UserStandRoleModel>;
}) =>
  standistCollection.map((user: UserModel, userIndex) => {
    const userStandRole = userStandRoleCollection.find(
      (usr: UserStandRoleModel) => usr.userIri === user.iri && usr.standistRole === standistRole
    ) as UserStandRoleModel;

    return (
      <React.Fragment key={user.id}>
        <a onClick={() => handleOnClick(user)}>{userStandRole?.fullName || user.fullName}</a>
        {(userIndex || 0) + 1 !== standistCollection.length && <span>, </span>}
      </React.Fragment>
    );
  }),
);

export default Standists;
